import { fetchApi } from '@/config/axiosSetting';
import { GetReportTypeQueryResponseType } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getReportType/getReportTypeQuery.type';

export const getReportTypeFunction = (): Promise<
  GetReportTypeQueryResponseType[]
> => {
  return fetchApi.get('selection_item/police_report_type/wop_list/');
};
